import React from 'react';
import { maskMoney, maskRichText, portionSwitch } from '../../masks';
import CheckboxCounter from '../form/CheckboxCounter';

class ServiceDish extends React.Component {
  render() {
    const { dish, menuSelections } = this.props;
    return (
      <tr className="table__tr--underline">
        <td className="table__td menu-dish__view">
          {this.renderCheckboxCounter(dish, menuSelections)}
        </td>
        <td className="table__td menu-dish__view menu-dish__view--name">
          <p className="p">
            {dish.name || '-'}{' '}
            <span className="p--em p--new-line">{dish.child_name || ''}</span>
          </p>
        </td>
        <td className="table__td menu-dish__view menu-dish__view--course">
          <p className="p">{dish.course_name || '-'}</p>
        </td>
        <td className="table__td menu-dish__view menu-dish__view--ingredients">
          {maskRichText(dish.public_ingredients || '<p>-</p>')}
        </td>
        <td className="table__td menu-dish__view menu-dish__view--price">
          <p className="p">{maskMoney(dish.price_cents) || '-'}</p>
        </td>
        <td className="table__td menu-dish__view menu-dish__view--diet">
          <p className="p">{this.renderDiet(dish.dietary_preference_tags)}</p>
        </td>
      </tr>
    );
  }

  renderDiet(diets) {
    return diets.map(diet => diet.abbreviation).join(', ') || '-';
  }

  renderCheckboxCounter(dish, menuSelections = []) {
    const index = menuSelections.findIndex(selection =>
      this.isMatch(selection, dish)
    );
    const quantity = index >= 0 ? menuSelections[index].quantity : 0;

    return (
      <CheckboxCounter
        name={`${dish.id}`}
        value={quantity || 0}
        onChange={({ value }) => this.handleChange(dish, value)}
      />
    );
  }

  handleChange = (dish, quantity) => {
    const menuSelections = [...this.props.menuSelections];
    const index = menuSelections.findIndex(selection =>
      this.isMatch(selection, dish)
    );

    // if it exists and there's a quantity, update existing
    if (index >= 0 && quantity > 0) {
      const menuSelection = { ...menuSelections[index] };
      menuSelection.quantity = quantity;
      menuSelections[index] = menuSelection;
    }
    // if it exists and there's no quantity, delete existing
    else if (index >= 0 && quantity <= 0) {
      menuSelections.splice(index, 1);
    }
    // if it doesn't exist, create new
    else {
      const menuSelection = {
        dish,
        dish_id: dish.id,
        quantity,
        notes: '',
        course_name: this.props.courseName || '',
        portion: portionSwitch(this.props.portion)
      };
      menuSelections.push(menuSelection);
    }

    this.props.updateMenuSelections(menuSelections);
  };

  isMatch = (selection, dish) =>
    selection.menu_dish_id === dish.id || selection.dish_id === dish.id;
}

export default ServiceDish;



// WEBPACK FOOTER //
// ./src/components/service/ServiceDish.js